/** Textos do lote 4 (ponto oficial REP-P e arquivos fiscais). Sem travessão e sem emoji. */
const pt = {
  repP: 'Ponto oficial (REP-P)',
  avisoRepP:
    'Desligado, o módulo é o controle interno de jornada. Ligado, cada marcação do aplicativo e da tela recebe o NSR e o hash do AFD. Para valer como ponto oficial, a lei pede também o registro do programa no INPI, o atestado técnico e o termo de responsabilidade do desenvolvedor e o certificado digital ICP-Brasil do empregador.',
  avisoLigar: 'Ligar o REP-P grava o registro da empresa no AFD e não tem volta na sequência: desligar só para de gravar, e religar continua a mesma numeração.',
  editar: 'Editar o ponto oficial',
  gerar: 'Gerar arquivo',
  gerarTitulo: 'Gerar arquivo fiscal',
  avisoGerar: 'O arquivo é da empresa escolhida. Com o certificado digital A1 configurado em Integrações > Conectores, sai também a assinatura (.p7s).',
  semEmpresa: 'Escolha a empresa.',
  baixar: 'Baixar',
  baixarAssinatura: 'Assinatura (.p7s)',
  comprovante: 'Comprovante',
  baixarComprovante: 'Baixar comprovante (PDF)',
  vazio: 'Nenhum arquivo fiscal gerado ainda.',
  gerado: 'Arquivo gerado',
  oficial: 'Oficial',
  naoOficial: 'Não oficial',
  ligado: 'Ligado',
  desligado: 'Desligado',
  campos: {
    ativo: 'Ponto oficial (REP-P) ligado',
    inpi: 'Registro do programa no INPI',
    inpiAjuda: 'Número do certificado de registro de programa de computador (até 17 dígitos). Sem ele, os arquivos saem "não oficiais".',
    local: 'Local da prestação do serviço',
    caepfCno: 'CAEPF ou CNO',
    caepfCnoAjuda: 'Só quando existir: CAEPF tem 14 dígitos e CNO, 12.',
    desenvolvedorDocumento: 'CNPJ ou CPF do desenvolvedor do programa',
    desenvolvedorRazao: 'Razão social do desenvolvedor',
    desenvolvedorEmail: 'E-mail do desenvolvedor',
    desenvolvedorAjuda: 'Vai no cabeçalho do AFD e no registro 08 do AEJ.',
    certificado: 'Certificado digital A1',
    nsr: 'Último NSR',
    tipo: 'Arquivo',
    periodo: 'Período',
    de: 'De',
    ate: 'Até',
    empresa: 'Empresa',
    registros: 'Registros',
    situacao: 'Situação',
    geradoEm: 'Gerado em',
    geradoPor: 'Gerado por',
  },
  tipo: { afd: 'AFD (marcações do REP-P)', aej: 'AEJ (jornada tratada)' },
  certificado: { sim: 'Configurado', nao: 'Não configurado (Integrações > Conectores)' },
};

const en: typeof pt = {
  repP: 'Official time clock (REP-P)',
  avisoRepP:
    'Off, the module is the internal working hours control. On, each punch from the app and the screen gets the AFD NSR and hash. To count as the official time clock, the law also requires the program registration at INPI, the developer technical statement and liability term, and the employer ICP-Brasil digital certificate.',
  avisoLigar: 'Turning REP-P on writes the company record in the AFD and the sequence cannot go back: turning it off only stops writing, and turning it on again continues the same numbering.',
  editar: 'Edit the official time clock',
  gerar: 'Generate file',
  gerarTitulo: 'Generate fiscal file',
  avisoGerar: 'The file is for the chosen company. With the A1 digital certificate set up under Integrations > Connectors, the signature (.p7s) comes too.',
  semEmpresa: 'Choose the company.',
  baixar: 'Download',
  baixarAssinatura: 'Signature (.p7s)',
  comprovante: 'Receipt',
  baixarComprovante: 'Download receipt (PDF)',
  vazio: 'No fiscal file generated yet.',
  gerado: 'File generated',
  oficial: 'Official',
  naoOficial: 'Not official',
  ligado: 'On',
  desligado: 'Off',
  campos: {
    ativo: 'Official time clock (REP-P) on',
    inpi: 'Program registration at INPI',
    inpiAjuda: 'Number of the computer program registration certificate (up to 17 digits). Without it, files come out "not official".',
    local: 'Place of work',
    caepfCno: 'CAEPF or CNO',
    caepfCnoAjuda: 'Only when it exists: CAEPF has 14 digits and CNO, 12.',
    desenvolvedorDocumento: 'Program developer tax ID (CNPJ or CPF)',
    desenvolvedorRazao: 'Developer company name',
    desenvolvedorEmail: 'Developer email',
    desenvolvedorAjuda: 'It goes in the AFD header and in AEJ record 08.',
    certificado: 'A1 digital certificate',
    nsr: 'Last NSR',
    tipo: 'File',
    periodo: 'Period',
    de: 'From',
    ate: 'To',
    empresa: 'Company',
    registros: 'Records',
    situacao: 'Status',
    geradoEm: 'Generated at',
    geradoPor: 'Generated by',
  },
  tipo: { afd: 'AFD (REP-P punches)', aej: 'AEJ (processed working hours)' },
  certificado: { sim: 'Set up', nao: 'Not set up (Integrations > Connectors)' },
};

const es: typeof pt = {
  repP: 'Control oficial (REP-P)',
  avisoRepP:
    'Apagado, el módulo es el control interno de jornada. Encendido, cada registro de la aplicación y de la pantalla recibe el NSR y el hash del AFD. Para valer como control oficial, la ley pide también el registro del programa en el INPI, el certificado técnico y el término de responsabilidad del desarrollador y el certificado digital ICP-Brasil del empleador.',
  avisoLigar: 'Encender el REP-P graba el registro de la empresa en el AFD y la secuencia no vuelve atrás: apagar solo deja de grabar, y encender de nuevo sigue la misma numeración.',
  editar: 'Editar el control oficial',
  gerar: 'Generar archivo',
  gerarTitulo: 'Generar archivo fiscal',
  avisoGerar: 'El archivo es de la empresa elegida. Con el certificado digital A1 configurado en Integraciones > Conectores, sale también la firma (.p7s).',
  semEmpresa: 'Elige la empresa.',
  baixar: 'Descargar',
  baixarAssinatura: 'Firma (.p7s)',
  comprovante: 'Comprobante',
  baixarComprovante: 'Descargar comprobante (PDF)',
  vazio: 'Ningún archivo fiscal generado todavía.',
  gerado: 'Archivo generado',
  oficial: 'Oficial',
  naoOficial: 'No oficial',
  ligado: 'Encendido',
  desligado: 'Apagado',
  campos: {
    ativo: 'Control oficial (REP-P) encendido',
    inpi: 'Registro del programa en el INPI',
    inpiAjuda: 'Número del certificado de registro de programa de computadora (hasta 17 dígitos). Sin él, los archivos salen "no oficiales".',
    local: 'Lugar de prestación del servicio',
    caepfCno: 'CAEPF o CNO',
    caepfCnoAjuda: 'Solo cuando exista: el CAEPF tiene 14 dígitos y el CNO, 12.',
    desenvolvedorDocumento: 'CNPJ o CPF del desarrollador del programa',
    desenvolvedorRazao: 'Razón social del desarrollador',
    desenvolvedorEmail: 'Correo del desarrollador',
    desenvolvedorAjuda: 'Va en el encabezado del AFD y en el registro 08 del AEJ.',
    certificado: 'Certificado digital A1',
    nsr: 'Último NSR',
    tipo: 'Archivo',
    periodo: 'Período',
    de: 'Desde',
    ate: 'Hasta',
    empresa: 'Empresa',
    registros: 'Registros',
    situacao: 'Situación',
    geradoEm: 'Generado el',
    geradoPor: 'Generado por',
  },
  tipo: { afd: 'AFD (registros del REP-P)', aej: 'AEJ (jornada tratada)' },
  certificado: { sim: 'Configurado', nao: 'No configurado (Integraciones > Conectores)' },
};

export const i18nFiscal = { pt, en, es };
